import React from 'react'
import SpainTemplateDefault from 'src/components/template/es'

const annotations = [
  {
    startSecs: '0',
    endSecs: '5.1',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/syfy/annotations/Arrow_logo_white.png',
  },
  {
    startSecs: '5.11',
    endSecs: '11.1',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/syfy/annotations/Limetown_logo_white.png',
  },
  {
    startSecs: '11.11',
    endSecs: '16.1',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/syfy/annotations/Missions_logo_white.png',
  },
  {
    startSecs: '16.11',
    endSecs: '22.1',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/syfy/annotations/ResidentAlien_logo_white.png',
  },
  {
    startSecs: '22.11',
    endSecs: '40.0',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/syfy/annotations/VagrantQueen_logo_white.png',
  },
]

const pageTitle = 'SERIES INTERNACIONALES DE ACCIÓN Y FICCIÓN'
const pageDescription =
  'Ver Movistar Series en directo y bajo demanda. Fubo es un servicio de TV por Internet que ofrece canales de televisión con programas de entretenimiento en directo y los eventos deportivos más prestigiosos del mundo. El servicio ofrece acceso a canales nacionales y locales a través de TV, tablets, dispositivos móviles y portátiles.'

export default (props) => {
  return (
    <SpainTemplateDefault
      location={props.location}
      lang="es"
      market="spain"
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      video="https://assets.fubo.tv/marketing/lp/videos/compressed/Syfy_LP_30s.mp4"
      title="SYFY EN DIRECTO Y A LA CARTA"
      subtitle="Desde solo 3,99€/mes"
      annotations={annotations}
    />
  )
}
